import './DownloadButton.css'
import React from 'react'
import MergedPDFDownload from './MergedPDFDownload'

export default function DownloadButton({
  generateMergedPdf,
  mergedPdfStatus,
}) {
  return (
    <div
      style={{
        minWidth: '50px',
        paddingLeft: '10px',
        paddingRight: '10px',
        textAlign: 'center'
      }}
    >
      <MergedPDFDownload
        generateMergedPdf={generateMergedPdf}
        mergedPdfStatus={mergedPdfStatus}
      />
    </div>
  )
}
